import React, { useCallback, useEffect, useState } from 'react';
import { useFolderListenerContext } from '../../../providers/FolderListenerContextProvider';
import { K_INFO } from '../../../providers/ConfigsDataContextProvider';
import WizardFolderEdit from './WizardFolderEdit';
import WizardFolderLabel from './WizardFolderLabel';
import './WizardFolderCtrl.css';


const WizardFolderCtrl = ({parentFolderPath, parentFolder, folderName, stepName, withError}) => {
  const [editMode, setEditMode] = useState(false);
  const [locked, setLocked]     = useState(false);
  const [justCreated, setJustCreated] = useState(false);
  const {tagFolderLocked, clearFolderLocked}= useFolderListenerContext();  
  const [errInfo, setErrInfo] = useState(withError);


  //------ Switch to EditMode (unless locked)
  //
  const switchToEditMode = useCallback(() => {
    if (!locked) {
      setEditMode(true);
    }
    else {
      // indication of a locked click...
      console.log('Key LOCKED');
    }
  }, [locked]);

  //------ Switch To Label Mode
  //
  const switchToLabelMode = useCallback(()=>{
    setEditMode(false);
  },[]);


  //------  Effect kInfo  ------
  //
  useEffect(()=>{
    if (parentFolder) {
      if (parentFolder[folderName]) {
        const kInfo = parentFolder[folderName][K_INFO];
        if (Boolean(kInfo.folderEdit) || Boolean(withError)) {
          switchToEditMode();
        }
        setErrInfo(withError);
        setLocked(kInfo.folderLocked);
        setJustCreated(kInfo.folderJustCreated);
      }
    }         
  }, [parentFolder, folderName, switchToEditMode, withError]);

  
  //------  Lock Me ------
  //
  const lockMe = useCallback((e) =>{
    clearFolderLocked(parentFolderPath, folderName)
      .then(setLocked(false));
  }, [clearFolderLocked, parentFolderPath, folderName]);


  return (
    <div className='wizardFolderCtrl'>
      {editMode && <WizardFolderEdit parentFolderPath={parentFolderPath} parentFolder={parentFolder} folderName={folderName} switchToLabel={switchToLabelMode} withError={errInfo}/>}
      {!editMode && <WizardFolderLabel parentFolderPath={parentFolderPath} folderName={folderName} stepName={stepName} switchToEdit={switchToEditMode}/>}
    </div>
  );
};

export default WizardFolderCtrl;